import { Show } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { HelpCircle } from "untitledui-js-base";
import { FullApplicant } from "views/applications-id/components/ApplicantsTable/types";

export const AuditSummaryFlag = ({
  audit_summary_flags
}: {
  audit_summary_flags: FullApplicant["audit_summary_flags"];
}) => {
  return (
    <div className="flex gap-2 items-center">
      <Tooltip>
        <TooltipTrigger as="div" className="cursor-pointer text-left">
          <HelpCircle className="stroke-white fill-danger-500" size="20" />
        </TooltipTrigger>

        <TooltipContent className="max-w-[480px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-content-1000-inverted shadow-xs">
          <Show if={audit_summary_flags.application_id_changed}>
            No data available. Application was transferred from a group for
            which this data was not requested
          </Show>

          <Show if={audit_summary_flags.unit_id_changed}>
            No data available. Application was moved from a unit where this data
            was not requested
          </Show>

          <Show if={audit_summary_flags.role_changed}>
            No data available. Role has been changed after submission
          </Show>
        </TooltipContent>
      </Tooltip>
      <p className="text-sm font-bold text-danger-500">-</p>
    </div>
  );
};
